import { ProductTypeEnum, ProductFamilyEnum } from "@src/apis/ModularClient"; // Adjust the import path as needed

export const getProductTypeDisplayText = (
  productType: ProductTypeEnum,
  isRegulatedBridging: boolean = false,
): string => {
  let displayText: string;

  switch (productType) {
    case ProductTypeEnum.Development:
      displayText = "Development Finance";
      break;
    case ProductTypeEnum.BridgingPreconstruction:
      displayText = "Planning Bridge";
      break;
    case ProductTypeEnum.BridgingPurchaseOrRefinance:
      displayText = isRegulatedBridging ? "Regulated" : "Purchase / Refinance";
      break;
    case ProductTypeEnum.BridgingDeveloperExit:
      displayText = "Developer Exit";
      break;
    case ProductTypeEnum.BridgingRefurb:
      displayText = isRegulatedBridging ? "Regulated" : "Refurbishment";
      break;
    case ProductTypeEnum.CommercialInvestment:
      displayText = "Commercial Investment";
      break;
    case ProductTypeEnum.CommercialOwnerOccupied:
      displayText = "Owner Occupied Mortgage";
      break;
    default:
      displayText = "Undefined";
      break;
  }

  return displayText;
};

export const getProductTypeSearchName = (productType: ProductTypeEnum): string => {
  let displayText: string;

  switch (productType) {
    case ProductTypeEnum.Development:
      displayText = "Development Finance";
      break;
    case ProductTypeEnum.BridgingPreconstruction:
      displayText = "Planning Bridge";
      break;
    case ProductTypeEnum.BridgingPurchaseOrRefinance:
      displayText = "Purchase / Refinance";
      break;
    case ProductTypeEnum.BridgingDeveloperExit:
      displayText = "Developer Exit";
      break;
    case ProductTypeEnum.BridgingRefurb:
      displayText = "Refurbishment";
      break;
    case ProductTypeEnum.CommercialInvestment:
      displayText = "Commercial Investment";
      break;
    case ProductTypeEnum.CommercialOwnerOccupied:
      displayText = "Owner Occupied";
      break;
    default:
      displayText = "Undefined";
      break;
  }

  return displayText;
};

export const getProductTypeFullName = (productType: ProductTypeEnum): string => {
  let displayText: string;

  switch (productType) {
    case ProductTypeEnum.Development:
      displayText = "Development Finance";
      break;
    case ProductTypeEnum.BridgingPreconstruction:
      displayText = "Planning Bridge";
      break;
    case ProductTypeEnum.BridgingPurchaseOrRefinance:
      displayText = "Purchase / Refinance Bridge";
      break;
    case ProductTypeEnum.BridgingDeveloperExit:
      displayText = "Developer Exit Bridge";
      break;
    case ProductTypeEnum.BridgingRefurb:
      displayText = "Refurbishment Bridge";
      break;
    case ProductTypeEnum.CommercialInvestment:
      displayText = "Commercial Investment Mortgage";
      break;
    case ProductTypeEnum.CommercialOwnerOccupied:
      displayText = "Commercial Owner Occupied Mortgage";
      break;
    default:
      displayText = "Undefined";
      break;
  }

  return displayText;
};

export const getProductFamilyByProductType = (productType: ProductTypeEnum): ProductFamilyEnum => {
  let productFamily: ProductFamilyEnum;

  switch (productType) {
    case ProductTypeEnum.Development:
      productFamily = ProductFamilyEnum.Development;
      break;
    case ProductTypeEnum.BridgingPreconstruction:
    case ProductTypeEnum.BridgingPurchaseOrRefinance:
    case ProductTypeEnum.BridgingDeveloperExit:
    case ProductTypeEnum.BridgingRefurb:
    case ProductTypeEnum.Bridging:
      productFamily = ProductFamilyEnum.Bridging;
      break;
    case ProductTypeEnum.CommercialInvestment:
    case ProductTypeEnum.CommercialOwnerOccupied:
    case ProductTypeEnum.CommercialAll:
      productFamily = ProductFamilyEnum.Commercial;
      break;
    default:
      productFamily = ProductFamilyEnum.None;
      break;
  }

  return productFamily;
};

/**
 * Text to send to Google Analytics
 * @param productType
 * @param isRegulatedBridging
 */
export const getProductTypeTextForGa = (productType: ProductTypeEnum, isRegulatedBridging: boolean = false): string => {
  let displayText: string;

  switch (productType) {
    case ProductTypeEnum.Development:
      displayText = "Development Finance";
      break;
    case ProductTypeEnum.BridgingPreconstruction:
      displayText = "Planning Bridge";
      break;
    case ProductTypeEnum.BridgingPurchaseOrRefinance:
      displayText = isRegulatedBridging ? "Purchase / Refinance Regulated" : "Purchase / Refinance";
      break;
    case ProductTypeEnum.BridgingDeveloperExit:
      displayText = "Developer Exit";
      break;
    case ProductTypeEnum.BridgingRefurb:
      displayText = isRegulatedBridging ? "Refurbishment Regulated" : "Refurbishment";
      break;
    case ProductTypeEnum.CommercialInvestment:
      displayText = "Commercial Investment";
      break;
    case ProductTypeEnum.CommercialOwnerOccupied:
      displayText = "Owner Occupied Mortgage";
      break;
    default:
      displayText = "Undefined";
      break;
  }

  return displayText;
};

/**
 * Text to send to Google Analytics
 * @param productFamily
 */
export const getProductFamilyTextForGa = (productFamily: ProductFamilyEnum): string => {
  let displayText: string;

  switch (productFamily) {
    case ProductFamilyEnum.Development:
      displayText = "Development Finance";
      break;
    case ProductFamilyEnum.Bridging:
      displayText = "Bridging";
      break;
    case ProductFamilyEnum.Commercial:
      displayText = "Commercial";
      break;
    default:
      displayText = "Undefined";
      break;
  }

  return displayText;
};

const ProductHelper = {
  getProductTypeDisplayText,
  getProductTypeSearchName,
  getProductTypeFullName,
  getProductFamilyByProductType,
  getProductTypeTextForGa,
  getProductFamilyTextForGa,
};

export default ProductHelper;
